import { render } from "./BaseList.vue?vue&type=template&id=8c8b7c26&scoped=true"
import script from "./BaseList.vue?vue&type=script&lang=js"
export * from "./BaseList.vue?vue&type=script&lang=js"

import "./BaseList.vue?vue&type=style&index=0&id=8c8b7c26&lang=scss&scoped=true"
import "./BaseList.vue?vue&type=style&index=1&id=8c8b7c26&lang=scss"
script.render = render
script.__scopeId = "data-v-8c8b7c26"

export default script